module.exports = __webpack_public_path__ + "static/media/it-support.cd83bfec.jpg";